import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-anlegen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenAufgabeAnlegenEffects {

    AufgabeAnlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_ANLEGEN),
        mergeMap((x: ac.PostAufgabeAnlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeAnlegen(x.aufgabeModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeAnlegenErfolgreichAction(result, x.aufgabeModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeAnlegenFehlerAction(error, x.aufgabeModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
